import _t from 'i18n!nls/enterprise-admin-skills';

export enum SkillLevels {
  conversant = 'CONVERSANT',
  beginner = 'BEGINNER',
  intermediate = 'INTERMEDIATE',
  advanced = 'ADVANCED',
}

export const getSkillRangeLabels = () => ({
  [SkillLevels.conversant]: {
    index: 0,
    level: _t('Conversant'),
    range: _t('1-50'),
  },
  [SkillLevels.beginner]: {
    index: 1,
    level: _t('Beginner'),
    range: _t('51-150'),
  },
  [SkillLevels.intermediate]: {
    index: 2,
    level: _t('Intermediate'),
    range: _t('151-350'),
  },
  [SkillLevels.advanced]: {
    index: 3,
    level: _t('Advanced'),
    range: _t('351-500'),
  },
});

export const getSkillRangeLabelsByScore = (score: number) => {
  const labels = getSkillRangeLabels();
  if (score < 51) {
    return labels[SkillLevels.conversant];
  } else if (score < 151) {
    return labels[SkillLevels.beginner];
  } else if (score < 351) {
    return labels[SkillLevels.intermediate];
  } else {
    return labels[SkillLevels.advanced];
  }
};

export const getSkillRangeLabelsByLevel = (level: SkillLevels) => {
  const labels = getSkillRangeLabels();
  return labels[level];
};
